import { render, staticRenderFns } from "./InformeIndividual.vue?vue&type=template&id=330ca5eb"
import script from "./InformeIndividual.vue?vue&type=script&lang=js"
export * from "./InformeIndividual.vue?vue&type=script&lang=js"
import style0 from "./InformeIndividual.vue?vue&type=style&index=0&id=330ca5eb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports